/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { Acknowledgement } from '../components/Acknowledgement';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import React, { useEffect, useState } from 'react';
import { config } from '../config/success.config';
import { useSMAppNavigator } from '@/AppNavigator/machines/pageContent';
import { useNavigate } from 'react-router-dom';
import './styles.css';
import { usePaymentId } from '../provider';

export const ContainerComm = (props: any) => {
  const { onNavigate } = props;
  const navigate = useNavigate();
  const { appNavigatorSend } = useSMAppNavigator({});

  const { message, paymentId } = usePaymentId();
  console.log('message + paymentId', message, '+', paymentId);
  useEffect(() => {
    const iframeUrl = window.location.href;
    console.log('URL inside the iframe2:', iframeUrl);
    const { message, paymentId } = usePaymentId();
    console.log('message + paymentId', message, '+', paymentId);
    // You can use the URL as needed within the iframe

    // For example, you might want to send the URL to the parent window
    window.parent.postMessage(iframeUrl, '*');
  }, []);

  const [showCloseButton, setShowCloseButton] = useState(false);
  // useEffect(() => {
  //   // Show close button after 5 seconds
  //   const timeoutId = setTimeout(() => {
  //     setShowCloseButton(true);
  //   }, 5000);

  //   return () => {
  //     // Clear the timeout on component unmount
  //     clearTimeout(timeoutId);
  //   };
  // }, []);

  const handleCloseButtonClick = () => {
    // Handle close button click, e.g., navigate or perform other actions
    // For now, let's just log a message
    console.log('Close button clicked!');
    appNavigatorSend('TRIGGER_REFRESH', {});
    navigate(`/applications-being-processed`);
  };
  return (
    <>
      {/*   
        <div className="close-button-container">
        <button onClick={handleCloseButtonClick} className="close-button">
          Close
        </button>
      </div> */}

      <Acknowledgement {...config} paymentId={paymentId} />
    </>
  );
};

ContainerComm.defaultProps = {};
